import React, { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Route, Redirect } from 'react-router'

const parseQueryParams = query => (
  query ? (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=')
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '' // eslint-disable-line
      return params
    }, { }) : {}
)

export const goBackOr = (path, history) => {
  if (history.length > 1) {
    history.goBack()
  } else {
    history.push(path)
  }
}

export const withQueryParams = WrappedComponent => @withRouter
  class WithQueryParamsComponent extends Component {
    static propTypes = {
      location: PropTypes.any,
    }

    render() {
      const { location } = this.props
      const queryParams = parseQueryParams(location.search)
      return createElement(WrappedComponent, {
        ...this.props,
        queryParams
      })
    }
}

export const RedirectWithQuery = ({ from, to }) => (
  <Route
    path={from}
    component={({ location }) => (
      <Redirect
        to={{
          ...location,
          pathname: location.pathname.replace(new RegExp(from, 'i'), to),
        }}
      />
    )}
  />
)

RedirectWithQuery.propTypes = {
  from: PropTypes.any,
  to: PropTypes.any,
}
